import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputMask from 'react-input-mask';
import {
  Modal as AntdModal,
  Divider,
  Button,
  Row,
  Col,
  Input as InputAntd,
  Select,
  Form,
  Typography,
} from 'components/Shared/Antd';
import validationScheme from './validationScheme';
import { ModalProps } from './types';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import Input from 'components/Shared/Input';
import Field from 'components/Shared/Field';
import { cleanString } from 'helpers/functions';
import authService from 'services/auth';
import RxOp from 'rxjs-operators';
import Toast from 'components/Shared/Toast';

const Modal = ({ onSubmit, subjects, handleClose, open, loading, name, email }: ModalProps) => {
  const form = useForm({
    resolver: yupResolver(validationScheme),
    defaultValues: {
      client_name: name,
      client_contact: email,
    },
    mode: 'onChange',
  });

  React.useEffect(() => {
    if (name && email) {
      return;
    }

    const obs = authService
      .getUser()
      .pipe(RxOp.logError())
      .subscribe(
        data => {
          form.setValue('client_contact', data?.user_email);
          form.setValue('client_name', data?.user_name);
        },

        err => {
          if (err.message === 'Request failed with status code 403') {
            Toast.error(
              'Permissão Negada. O administrador desta conta não lhe concedeu privilégio para acessar este recurso',
              6000,
            );
          }
        },
      );

    return () => {
      obs.unsubscribe();
    };
  }, [email, form, name]);

  const options = Object.entries(subjects).map(([value, text]) => ({ value, label: text }));

  const phone = form.watch('phone');

  const handlePastePhone = e => {
    const phone = e.clipboardData.getData('Text');
    form.setValue('phone', cleanString(phone));
  };
  return (
    <AntdModal
      title='Precisa de ajuda?'
      open={open}
      closeIcon={<CloseOutlined onClick={handleClose} />}
      width={600}
      footer={[
        <React.Fragment key='primary'>
          <Divider />
          <Button onClick={handleClose} style={{ marginBottom: '10px' }} key='close-btn' id='cancel-helpmessage-btn'>
            Cancelar
          </Button>
          <Button
            disabled={loading}
            onClick={form.handleSubmit(onSubmit)}
            key='send-btn'
            type='primary'
            id='send-helpmessage-btn'
          >
            {loading ? 'Aguarde ... ' : 'Enviar mensagem'}
          </Button>
        </React.Fragment>,
      ]}
    >
      <Typography style={{ marginBottom: '32px' }}>Entraremos em contato com você por e-mail</Typography>
      <FormProvider {...form}>
        <Form>
          <Row gutter={[16, 16]}>
            <Col md={12} xs={24}>
              <Typography.Text>Motivo do contato</Typography.Text>
              <Field
                name='subject'
                render={
                  <Select size='large' options={options} style={{ width: '100%' }} placeholder='Selecione o motivo' />
                }
              />
            </Col>
            <Col md={12} xs={24}>
              <Input legend='Nome' placeholder='Insira o nome' name='client_name' disabled />
            </Col>
            <Col md={12} xs={24}>
              <Input legend='Email' placeholder='Insira o email' name='client_contact' disabled />
            </Col>

            <Col md={12} xs={24}>
              <Typography.Text>Telefone</Typography.Text>
              <Field
                name='client_phone'
                render={
                  <InputMask
                    onPaste={handlePastePhone}
                    mask={phone && cleanString(phone)[2] === '3' ? '(99) 9999-9999' : '(99) 99999-9999'}
                  >
                    <InputAntd size='large' placeholder='Código DDD + Nº do telefone' maxLength={20} />
                  </InputMask>
                }
              />
            </Col>
            <Col md={24} xs={24}>
              <Typography.Text>Mensagem</Typography.Text>
              <Field
                name='message'
                render={
                  <InputAntd.TextArea
                    rows={6}
                    showCount
                    placeholder='Digite aqui sua mensagem para o produtor'
                    maxLength={1000}
                  />
                }
              />
            </Col>
          </Row>
        </Form>
      </FormProvider>
    </AntdModal>
  );
};
export default Modal;
